import store from './configureStore';

export default store;
